import { Link } from "react-router-dom";
import { Space, theme as antdTheme } from "antd";
import { APP_NAME } from "@/theme/tokens";

/** Title/logo do sider (Refine `<ThemedLayout Title={...}>`). */
export const MelTitle: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { token } = antdTheme.useToken();
  return (
    <Link
      to="/"
      style={{ textDecoration: "none", color: token.colorText }}
      aria-label={APP_NAME}
    >
      <Space size={8} align="center" style={{ padding: "4px 0" }}>
        <img src="/mel-icon.svg" alt="" width={28} height={28} />
        {!collapsed && (
          <span
            style={{
              fontWeight: 700,
              fontSize: 18,
              background: "linear-gradient(135deg,#06B6D4 0%,#2DD4BF 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {APP_NAME}
          </span>
        )}
      </Space>
    </Link>
  );
};
